import { render } from "./payComplate.vue?vue&type=template&id=2f675dea&scoped=true"
import script from "./payComplate.vue?vue&type=script&lang=js"
export * from "./payComplate.vue?vue&type=script&lang=js"

import "./payComplate.vue?vue&type=style&index=0&id=2f675dea&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f675dea"]])

export default __exports__